import dayjs from '@store/timetable/dayjs.config'

export const DEFAULT_DATES = {
  startDate: dayjs().format('YYYY-MM-DD'),
  endDate: dayjs().add(-1, 'month').format('YYYY-MM-DD'),
}
